import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import ToolBtn from './ToolBtn';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';
import SizePicker from './SizePicker';
import SizeBtn from './SizeBtn';
import ColorPicker from './ColorPicker';
import SoundAssetKeys from '../SoundAssetKeys';
import gameData from '../gameData';

export default class ToolPanel extends Phaser.GameObjects.Container {

  static get UI_CLICK() {return 'UI_CLICK';}

  constructor (scene) {
    super(scene);

    this.toolBtns = null;
    this.colorPicker = null;
    this.paletteOpen = null;
    let totalItemWidth = 0;
    const { gameConfig } = ABCyaLib.Environment.instance;
    const items = [];

    const tools = [
      { frameUnselected: UIAssetKeys._menu_btn, frameSelected: UIAssetKeys._menu_btn, event: ToolBtn.MENU_CLICKED, id: 'menu', showSelected: false },
      { frameUnselected: UIAssetKeys._grid_btn, frameSelected: UIAssetKeys._grid_btn, event: ToolBtn.GRID_CLICKED, id: 'grid', showSelected: false },
      { frameUnselected: UIAssetKeys._undo_btn, frameSelected: UIAssetKeys._undo_btn, event: ToolBtn.UNDO_CLICKED, id: 'undo', showSelected: false },
      { frameUnselected: UIAssetKeys._eraser_btn, frameSelected: UIAssetKeys._eraser_btn_active, event: ToolBtn.ERASE_CLICKED, id: 'eraser', showSelected: true },
      { frameUnselected: UIAssetKeys._fill_btn, frameSelected: UIAssetKeys._fill_btn_active, event: ToolBtn.FILL_CLICKED, id: 'fill', showSelected: true },
      { frameUnselected: UIAssetKeys._draw_btn, frameSelected: UIAssetKeys._draw_btn_active, event: ToolBtn.DRAW_CLICKED, id: 'draw', showSelected: true }
    ];
    this.toolBtns = [];

    tools.forEach((tool) => {
      const toolBtn = new ToolBtn(this.scene, tool.frameUnselected, tool.frameSelected, tool.event, tool.id, tool.showSelected);
      totalItemWidth += toolBtn.getBounds().width;
      items.push(toolBtn);
      this.toolBtns.push(toolBtn);

      toolBtn.on(tool.event, () => {
        if (this.paletteOpen) this.colorPicker.togglePaletteOpen(false);
      });
    });

    const menuBtn = this.toolBtns[0];
    const gridBtn = this.toolBtns[1];
    const undoBtn = this.toolBtns[2];
    const eraserBtn = this.toolBtns[3];
    const fillBtn = this.toolBtns[4];
    const drawBtn = this.toolBtns[5];

    const sizePicker = new SizePicker(this.scene);
    totalItemWidth += sizePicker.getBounds().width + menuBtn.getBounds().width / 2;
    items.push(sizePicker);

    this.colorPicker = new ColorPicker(this.scene);
    totalItemWidth += this.colorPicker.closedBg.getBounds().width;
    items.push(this.colorPicker);
    this.colorPicker.on(ColorPicker.COLOR_SELECT, this.handleColorSelect, this);
    this.colorPicker.on(ColorPicker.TOGGLE_PALETTE, (isOpen) => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pixel_art_select_sound, this.scene);
      this.paletteOpen = isOpen;
    });

    const spacing = (this.scene.scale.width - totalItemWidth) / (items.length + 1);
    let i = 0;
    while (i < items.length) {
      items[i].x = i === 0 ? spacing + menuBtn.getBounds().width / 2 : items[i - 1].x + items[i - 1].getBounds().width + spacing;
      items[i].y = i === (items.length - 1) ? this.scene.scale.height - 45 - (items[i].closedBg.getBounds().height / 2) : this.scene.scale.height - 45;

      if (i === items.length - 2) items[i].y = this.scene.scale.height - 45 - items[i].getBounds().height / 2;
      this.add(items[i]);
      i++;
    }

    this.toolBtns[5].showSelected(true);

    gridBtn.on(ToolBtn.GRID_CLICKED, (btn) => {
      this.gridBtnOn.setVisible(!btn.isSelected);
      this.gridBtnOff.setVisible(btn.isSelected);
      this.emit(ToolPanel.UI_CLICK, btn.toolBtnId);
    });

    menuBtn.on(ToolBtn.MENU_CLICKED, (btn) => {
      this.emit(ToolPanel.UI_CLICK, btn.toolBtnId);
    });

    undoBtn.on(ToolBtn.UNDO_CLICKED, (btn) => {
      this.emit(ToolPanel.UI_CLICK, btn.toolBtnId);
    });

    // eraser fill draw
    eraserBtn.on(ToolBtn.ERASE_CLICKED, btn => this.screenInteractionEventHandler(btn));
    fillBtn.on(ToolBtn.FILL_CLICKED, btn => this.screenInteractionEventHandler(btn));
    drawBtn.on(ToolBtn.DRAW_CLICKED, btn => this.screenInteractionEventHandler(btn));
    sizePicker.on(SizeBtn.SIZE_SELECT, (size) => {gameData.DRAW_SIZE = size;});

    // add icons to grid button
    this.gridBtnOn = ABCyaPhaser.Images.addImage(gridBtn.x, gridBtn.y - 2, UIAssetKeys._grid_btn_eye, this);
    this.gridBtnOff = ABCyaPhaser.Images.addImage(gridBtn.x, gridBtn.y - 2, UIAssetKeys._grid_btn_eye_closed, this).setVisible(false);
  };

  screenInteractionEventHandler(btn) {
    gameData.CURRENT_TOOL = btn.toolBtnId;
  }

  handleColorSelect(colorSelected) {
    gameData.DRAW_COLOR = colorSelected;
    if (this.paletteOpen) this.colorPicker.togglePaletteOpen(false);
  };
}